import { Link } from 'react-router';
import { ShieldCheckIcon, LogInIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { appIdentity } from '@/app/app-config';
import { PURPOSES } from '@/lib/purposes';

export function PublicFooter() {
  return (
    <footer className="border-t border-border bg-muted/20">
      <div className="mx-auto flex max-w-5xl flex-col gap-6 px-4 py-8">
        <div className="flex flex-col items-center gap-4 sm:flex-row sm:justify-between sm:text-left">
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <ShieldCheckIcon className="h-4 w-4" aria-hidden />
            <span>© {new Date().getFullYear()} {appIdentity.name}</span>
          </div>
          <Button asChild variant="ghost" size="sm" className="text-muted-foreground">
            <Link to="/workspace">
              <LogInIcon className="mr-1.5 h-3.5 w-3.5" aria-hidden />
              Staff sign in
            </Link>
          </Button>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 border-t border-border pt-4 text-center sm:justify-start sm:text-left">
          <span className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
            Who it&rsquo;s for
          </span>
          {PURPOSES.map((purpose) => (
            <Link
              key={purpose.slug}
              to={`/for/${purpose.slug}`}
              className="text-sm text-muted-foreground transition-colors hover:text-foreground"
            >
              {purpose.shortName}
            </Link>
          ))}
        </div>
      </div>
    </footer>
  );
}
